module.exports = __webpack_public_path__ + "7b72f3d5eedd2a23861b26f2258d99fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/missedCall.png
// module id = Q373
// module chunks = 27